<!--<div class="div-center" *ngIf="isSuperuser()">-->
<!--  <button class="button-main-blue" (click)="openCreateEventDialog(content)">Создать мероприятие</button>-->
<!--</div>-->
<div class="grid-container">
  <ng-container
    *ngFor="let state of events">
    <a routerLink="/events/{{state?.id}}/participants" class="grid-item">{{state?.name}}</a>
  </ng-container>
</div>

